import React, { useCallback, useRef } from "react";
import { usePopup } from "~hooks/usePopup";
import { ModalContent } from "~components/PopupComponents";

// 弹窗 ID 类型（PopupProvider 里自增 number）
type PopupId = number | null;

// 所有弹窗组件的 Props 基础约定
export interface BaseModalProps {
  onCancel?: () => void;
}

// 弹窗类型枚举（可扩展）
export type ModalType = "ModalContent";

// show 方法参数
export interface ShowModalOptions extends BaseModalProps {
  type?: ModalType;
  [key: string]: any; // 允许业务透传参数
}

export interface DialogInstance {
  show: (options?: ShowModalOptions) => Promise<any>;
  close: (id?: number) => void;
}

export const useModal = (): { Dialog: DialogInstance } => {
  const popup = usePopup();
  const popupId = useRef<PopupId>(null);
  // 组件映射（类型安全）
  const componentMap: Record<ModalType, React.ComponentType<any>> = {
    ModalContent,
  };

  const Dialog: DialogInstance = {
    show: useCallback(
      async (options: ShowModalOptions = {}) => {
        const Component =
          (options.type && componentMap[options.type]) || ModalContent;

        const p = popup.open({
          type: "center",
          content: React.createElement(Component, {
            ...options
          }),
        });
        popupId.current = p.id
        return popupId.current;
      },
      [popup]
    ),

    close: (id?: number) => {
      if (id) {
        popup.close(id);
      } else {
       if (popupId.current !== null) {
         popup.close(popupId.current);
       } else {
         popup.close();
       }
      }
    },
  };

  return { Dialog };
};
